// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__HUtjp","inputContainer":"Form_inputContainer__HYdK1","genericError":"Form_genericError___yokq","submitButton":"Form_submitButton__d1dGu"};